import { Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Tila_valmisIcon } from "src/components/icons/TilaIcons";
import { StyledButton } from "src/components/styled/StyledButton";
import { FPTilauksetContext } from "src/context/FPTilauksetContext";

export default function FPTilauksetFilterSources() {
  const { allKeikat, filterBySourceAsiakkaat, setFilterBySourceAsiakkaat } =
    useContext(FPTilauksetContext);

  const [sourceAsiakkaat, setSourceAsiakkaat] = useState([]);

  useEffect(() => {
    // compute the sourceAsiakkaat data from keikat without duplicates and include count
    const fetchedSourceAsiakkaat = allKeikat.reduce((acc, keikka) => {
      const existing = acc.find((item) => item.asiakasId === keikka.sourceAsiakasId);
      if (existing) {
        existing.count += 1;
      } else {
        acc.push({
          asiakasId: keikka.sourceAsiakasId,
          asiakasNimi: keikka.sourceAsiakasNimi,
          count: 1,
        });
      }
      return acc;
    }, []);
    setSourceAsiakkaat(fetchedSourceAsiakkaat);

    // Initially select all sourceAsiakkaat
    setFilterBySourceAsiakkaat(fetchedSourceAsiakkaat.map((asiakas) => asiakas.asiakasId));
  }, [allKeikat]);

  return (
    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
      {sourceAsiakkaat.map((asiakas) => (
        <div key={asiakas.asiakasId} style={{ flex: 1, display: "flex", alignItems: "center" }}>
          <StyledButton
            sx={{ flex: 1 }}
            key={asiakas.asiakasId}
            variant="outlined"
            color={filterBySourceAsiakkaat.includes(asiakas.asiakasId) ? "primary" : "secondary"}
            onClick={() => {
              setFilterBySourceAsiakkaat((prev) =>
                prev.includes(asiakas.asiakasId)
                  ? prev.filter((id) => id !== asiakas.asiakasId)
                  : [...prev, asiakas.asiakasId]
              );
            }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
                width: "100%",
                height: "30px",
              }}>
              <div>
                <Typography variant="body2" color="primary" align="center">
                  {asiakas.asiakasNimi}
                </Typography>
                {/* {!filterBySourceAsiakkaat.includes(asiakas.asiakasId) ? (
                  <Typography variant="caption" style={{ opacity: 0.5 }}>
                    Piilossa
                  </Typography>
                ) : (
                  <div />
                )} */}
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Tila_valmisIcon
                  color={
                    filterBySourceAsiakkaat.includes(asiakas.asiakasId) ? "success" : "warning"
                  }
                />
                <div>{asiakas.count}</div>
              </div>
            </div>
          </StyledButton>
        </div>
      ))}
    </div>
  );
}
